import { type Change, Fragment, Inline, type Value } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { FRAGMENT_ANNOTATION_BODY, INLINE_ANNOTATION } from '../types';

/**
 * Create an inline annotation.
 */
export function createAnnotation(): Inline {
    const annotation = Inline.create({
        type: INLINE_ANNOTATION,
        fragments: [
            Fragment.create({
                fragment: FRAGMENT_ANNOTATION_BODY,
                type: FRAGMENT_ANNOTATION_BODY,
                nodes: [createParagraph()],
            }),
        ],
    });

    return annotation;
}

/**
 * Test if the current selection can be wrapped in an annotation.
 * Only entire words can be annotated.
 */
export function isSelectionAnnotable(value: Value, withFragments = false): boolean {
    const { selection } = value;

    if (selection.isCollapsed) {
        return false;
    }

    const inlines = withFragments ? value.inlinesWithFragments : value.inlines;
    if (inlines.size > 0) {
        return false;
    }

    return true;
}

/**
 * Wrap the current selection with an inline annotation.
 */
export function wrapWithAnnotation(change: Change) {
    const annotation = createAnnotation();
    const fragment = annotation.getFragmentByKey(FRAGMENT_ANNOTATION_BODY)!;

    change.wrapInline(annotation);
    change.collapseToStartOf(fragment);
}
